import { createContext } from 'react';
import type { WebSocketService } from '../services/core/WebSocketService';
import type { WebSocketStatus } from '../types/websocket.types';

export interface WebSocketContextValue {
  service: WebSocketService | null;
  status: WebSocketStatus;
  isConnected: boolean;
  reconnect: () => void;
  disconnect: () => void;
}

export const WebSocketContext = createContext<WebSocketContextValue | null>(null);
